import { c as _c } from "react/compiler-runtime";
import Typography from '@classify/react-core-components/Typography';
import { styled } from '@classify/react-core-components/styles';
import { getActiveLang, translate } from '@openclassrooms/translations';
import { isoDateToLocaleShort } from '@openclassrooms/utils/date';
import type { Policy } from '../../../../types';
import ContentShortText from './ContentShortText';
import ContentText from './ContentText';
import ContentTitle from './ContentTitle';
import { addTitleLevel, flatten, group } from './services';
const Title = styled('span')({
  '& time': {
    fontWeight: 'bold'
  }
});
const InnerContent = styled('article')(({
  theme: {
    palette,
    spacing
  }
}) => ({
  '& h2': {
    marginTop: spacing(4),
    color: palette.brand.primary
  }
}));
type ContentProps = {
  policy: Policy;
};
export default function Content(t0) {
  const $ = _c(11);
  const {
    policy
  } = t0;
  if (!policy.sections) {
    return null;
  }
  let t1;
  if ($[0] !== policy) {
    const flattenedContentData = addTitleLevel(flatten(policy));
    const groupedContentData = group(flattenedContentData, "type", /content|shortContent/);
    t1 = groupedContentData.map(_temp3);
    $[0] = policy;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const content = t1;
  const updatedIsoDate = typeof policy.updatedAt === "string" ? policy.updatedAt : policy.updatedAt.date;
  let t2;
  if ($[2] !== updatedIsoDate) {
    t2 = translate("policies.messages.update_date", {
      updatedIsoDate,
      isoDateToLocaleShort: isoDateToLocaleShort(updatedIsoDate, getActiveLang())
    });
    $[2] = updatedIsoDate;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <Typography variant="body" dangerouslySetInnerHTML={{
      __html: t2
    }} component={Title} />;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== content) {
    t4 = <InnerContent>{content}</InnerContent>;
    $[6] = content;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <>{t3}{t4}</>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}
function _temp3(contentData) {
  if (!Array.isArray(contentData)) {
    if (contentData.type === "title") {
      return <ContentTitle key={`title_${contentData.id}`} contentData={contentData} />;
    }
    return null;
  }
  return group(contentData, "type", /content/).map(_temp2);
}
function _temp2(subContentData) {
  if (Array.isArray(subContentData)) {
    return <ContentText key={`text_${subContentData[0].id}`} content={subContentData.map(_temp).join("")} />;
  }
  return <ContentShortText key={`shortText_${subContentData.id}`} content={subContentData.content} />;
}
function _temp(item) {
  return item.content;
}